var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bullet_style",style:(`top:${_vm.top}px;`),attrs:{"id":"bullet"},on:{"click":function($event){return _vm.insertBullet(_vm.el)}}},[_c('div',{staticStyle:{"width":"420px"}}),_vm._v(" "),_c('div',{staticClass:"bullet-left_style",style:('height:' + (_vm.showCount + 2) * _vm.eHeight + 'px'),attrs:{"id":`bullet-left_${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }